import CatalogTyreFilterStore from '../../_flux/stores/catalog_filter_store/tyre';
import CatalogConfiguratorStore from '../../_flux/stores/catalog_configurator_store';
import LastUsedConfiguratorStore from '../../_flux/stores/last_used_configurator_store';
import CONFIGURATOR_TYPES from '../../_flux/constants/configurator_types';
import { setVisibleSectionsAction } from '../../_flux/actions/catalog_configurator_actions';
import { showSecondLayerAction, setValuesAction, setInStockAction, showAction, hideTyreIndexLinkAction } from '../../_flux/actions/catalog_configurator_actions';
import {showConfirmationLayerAction} from '../../_flux/actions/rego_lookup_actions';
import * as configuratorButtons from '../configurator_buttons/configurator_buttons';
import {types as productTypes} from '../../_constants/product/types';
import RegoLookupStore from '../../_flux/stores/rego_lookup_store';

export const onChangeSpecific = openFor => {
    const configuratorSource = LastUsedConfiguratorStore.getState().configuratorSource;
    const isVehicleOrRego =
      JSON.stringify(['indexes', 'postcode']) !== JSON.stringify(openFor) &&
      JSON.stringify(['postcode']) !== JSON.stringify(openFor);

    if(CONFIGURATOR_TYPES.VEHICLE_CONFIGURATOR === configuratorSource && isVehicleOrRego) {
        configuratorButtons.onOpenVehicleConfiguratorClick();
    } else if(CONFIGURATOR_TYPES.REGO_LOOKUP === configuratorSource && isVehicleOrRego) {
        const regoLookupValues = RegoLookupStore.getState().values;
        if (regoLookupValues.tyreOptions.length) {
            showConfirmationLayerAction();
        }
        configuratorButtons.onOpenRegoLookupClick();
    } else {
        hideTyreIndexLinkAction();
        setVisibleSectionsAction(openFor);
        if (openFor.length === 1 && openFor[0] === 'postcode') {
            showSecondLayerAction();
        }
        const currentPageType = CatalogConfiguratorStore.getState().pageOriginType;
        if (!CatalogConfiguratorStore.getState().visible) {
            setValuesAction(CatalogTyreFilterStore.getState());
            setInStockAction(currentPageType);
        }

        if (productTypes.TYRE_CAR === currentPageType) {
            configuratorButtons.onOpenTyreSizeConfiguratorClick();
        } else if (productTypes.TYRE_MOTO === currentPageType){
            configuratorButtons.onOpenMotoTyreSizeConfiguratorClick();
        }
    }
};
